import { render, staticRenderFns } from "./AccountTerminologyForm.vue?vue&type=template&id=360b0f88"
import script from "./AccountTerminologyForm.vue?vue&type=script&lang=js"
export * from "./AccountTerminologyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports